export type CustGetExternalCustomersApiResponse =
  /** status 200 Standard response */
  | ({
      source?: string | null;
      externalId?: string | null;
      discriminator?: string | null;
      businessAddress?: {
        externalId?: string | null;
        street?: string | null;
        descriptiveNumber?: string | null;
        orientationNumber?: string | null;
        city?: string | null;
        zip?: string | null;
        addressComplement?: string | null;
        country?: string | null;
        prefix?: string | null;
        district?: string | null;
        state?: string | null;
        postal?: string | null;
        coordinates?: {
          latitude: string;
          longitude: string;
        } | null;
      } | null;
      vatNumber?: string | null;
      registrationNumber?: string | null;
      tradeName?: string | null;
      foundingPerson?: {
        externalId?: string | null;
        hasMatch?: boolean | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
        address?: {
          street?: string | null;
          descriptiveNumber?: string | null;
          orientationNumber?: string | null;
          city?: string | null;
          zip?: string | null;
          addressComplement?: string | null;
          country?: string | null;
          prefix?: string | null;
          district?: string | null;
          state?: string | null;
          postal?: string | null;
          coordinates?: {
            latitude: string;
            longitude: string;
          } | null;
        } | null;
      } | null;
      contacts?: ({
        externalId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
        address?: {
          street?: string | null;
          descriptiveNumber?: string | null;
          orientationNumber?: string | null;
          city?: string | null;
          zip?: string | null;
          addressComplement?: string | null;
          country?: string | null;
          prefix?: string | null;
          district?: string | null;
          state?: string | null;
          postal?: string | null;
          coordinates?: {
            latitude: string;
            longitude: string;
          } | null;
        } | null;
      } | null)[];
    } | null)[]
  | /** status 204 Standard response */ undefined;

export type CustGetExternalCustomersApiArg = {
  name?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  legalNumber?: string | null;
  make?: string | null;
  vehicleType?: string | null;
};
export type CustPostCkkConsentApiResponse =
  | /** status 200 Standard response */ ({
      source?: string | null;
      url?: string | null;
      data?: {
        [key: string]: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type CustPostCkkConsentApiArg = {
  customerId?: string | null;
  /** CKKId, ... */
  externalId?: string | null;
  vehicleType?: string | null;
  /** Make constKey */
  vehicleMake?: string | null;
  'x-tenant'?: string | null;
  'x-branch'?: string | null;
};
export type CustGetCkkConsentStateApiResponse =
  | /** status 200 Standard response */ ({
      source?: string | null;
      consentState?: number | null;
      externalId?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type CustGetCkkConsentStateApiArg = {
  /** Omnetic customer id */
  customerId: string | null;
  /** Id from CKK GDPR system when known */
  ckkId?: string | null;
  /** vehicleType constKey */
  vehicleType?: string | null;
  /** Make constKey */
  vehiclemake?: string | null;
  /** ISO2 user language for toast translations */
  language?: string | null;
  /** Business Case number (BC000127) */
  bcNumber?: string | null;
  /** Business Case creation dateTime */
  bcCreatedAt?: string | null;
  /** send Omnetic for consentState=1....send Softvig for consentState=0 */
  'x-tenant': string | null;
  'x-branch'?: string | null;
};
